var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"WarningMessage"},[(_vm.vif)?_c('div',{staticClass:"p-2 d-flex flex-column text-center w-100 mt-3"},[_c('label',{staticClass:"alert alert-warning",domProps:{"textContent":_vm._s(_vm.vtext)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }